import { Box, Center } from '@mantine/core'
import React from 'react'

const RenderReplaceWrapper = ({
  children,
  backgroundColor,
}: {
  children: React.ReactNode
  backgroundColor: string
}): React.ReactElement => (
  <Box
    sx={(_theme) => ({
      backgroundColor,
      cursor: 'pointer',
    })}
  >
    <Center style={{ height: '90vh', flexDirection: 'column' }}>
      {children}
    </Center>
  </Box>
)

export default RenderReplaceWrapper
